export default {"src":"/_next/static/media/stop-record.c9da0491.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};